import { format, formatDistanceToNow, parseISO } from 'date-fns';

/**
 * Format a point value with comma separators and "pts" suffix.
 * e.g. 1000 → "1,000 pts"
 */
export function formatPoints(points: number): string {
  return `${points.toLocaleString('en-US')} pts`;
}

/**
 * Format an ISO date string as "Mar 23, 2026".
 */
export function formatDate(dateStr: string): string {
  try {
    const date = parseISO(dateStr);
    return format(date, 'MMM d, yyyy');
  } catch {
    return '';
  }
}

/**
 * Format an ISO date string as a human-readable relative time.
 * e.g. "2 hours ago", "just now", "3 days ago"
 */
export function formatRelativeTime(dateStr: string): string {
  try {
    const date = parseISO(dateStr);
    const diffMs = Date.now() - date.getTime();

    // Within 30 seconds → "just now"
    if (diffMs < 30_000) {
      return 'just now';
    }

    return formatDistanceToNow(date, { addSuffix: true });
  } catch {
    return '';
  }
}

/**
 * Capitalize the first letter of a string.
 * e.g. "hello world" → "Hello world"
 */
export function capitalize(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}
